"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaUtils = void 0;
var breakpointsDown = {
    xs: '575px',
    sm: '767px',
    md: '991px',
    lg: '1199px',
    xl: '1599px'
};
var breakpointsUp = {
    xs: '0px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1600px'
};
exports.mediaUtils = {
    down: function (key) { return "@media (max-width:".concat(breakpointsDown[key], ")"); },
    up: function (key) { return "@media (min-width:".concat(breakpointsUp[key], ")"); }
};
